<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">高級方案專屬</h1>
                        <h2>Trinka MS Word 外掛程式 ( 輕量版)</h2>
                        <p>體驗 Trinka Word 輕量版外掛程式，支援 Windows 與 Mac 平台。它能在您熟悉的 MS Word 軟體中即時檢查並修正您的寫作內容。</p>
                        <div class="btn-group">
                            <a (click)="scroll(target)" class="filled-btn" target="_blank">開始使用</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/maclite-banner.svg" width="489" height="563" alt="ms word" class="img-fluid md50">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white">完美支援 Mac、Windows 與 Office 365！</h3>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="cloud_key_features section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka Microsoft Word 外掛程式（輕量版）主要功能</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">Trinka MS Word 是一款整合於你熟悉的 Word 應用程式中的外掛程式，讓你在寫作過程中就能獲得專業的文法修正建議。Trinka 會自動檢查所有變更，讓你不錯過任何細節。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="/assets/images/grammar-checker-icon.svg" width="40" height="40" alt="Grammar Checker" />
                    <h3>英文文法檢查</h3>
                    <p>在 Word 編輯器中即時獲得寫作建議與高級文法修正，提升語句流暢度與專業度。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="/assets/images/multilingual-icon.png" width="40" height="40" alt="Grammar Checker" />
                    <h3>多語系文法檢查</h3>
                    <p>自動偵測語言，針對西班牙文內容提供文法修正，讓多語寫作也更精準。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="/assets/images/paraphraser-icon.svg" width="40" height="40" alt="Paraphraser">
                    <h3>AI 文章改寫工具（全新推出）</h3>
                    <p>在你寫作的同時，AI 會理解你的表達意圖，主動提供重寫建議，幫助你使內容更清晰、連貫且符合文法規範。
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/style_guide_icon.svg" width="40" height="40" alt="Style Guide Preferences">
                    <h3>學術寫作風格設定</h3>
                    <p>自訂文法與用字偏好，輕鬆符合主流學術寫作格式（如 AMA 第11版、AGU 2017）。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/AddtoDictionary.svg" width="40" height="40" alt="Mac Word | Add to Dictionary" />
                    <h3>新增至個人詞典</h3>
                    <p>將專屬詞彙加入「我的詞典」，Trinka 將自動略過這些詞的拼字檢查，讓您的專業用語保持一致。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/DataSecurityIcon.svg" width="40" height="40" alt="Data Security">
                    <h3>資料安全保障</h3>
                    <p>你輸入的內容會透過安全加密傳輸分析，資料絕不會被儲存，確保隱私無虞。
                    </p>
                </div>
            </div>
            
        </div>
    </div>
</section>

<section class="section-pd bg-light-purple" id="MSWordSteps" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>如何安裝 Trinka MS Word 外掛程式（輕量版）</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka 文法檢查工具的 MS Word 外掛程式輕量版（適用於 Windows 與 Mac）既快速又簡單。</p>
                    <p>若您目前使用的是基本方案，可升級至高級方案以解鎖此外掛程式，並享有更多高級功能。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd list-wrapper-style-2 pb-0">
        <div class="trinka_container container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>步驟1.</h3>
                        <ul class="bullet-list">
                            <li><span>開啟 Microsoft Word，點選「插入」(Insert) 標籤</span></li>
                            <li><span>點擊「商店」(Store) 圖示</span></li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image">
                        <img src="/assets/images/word-plugin/step1.webp" width="666" height="137" alt="step1" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd list-wrapper-style-2 pb-0">
        <div class="trinka_container container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2 pr-80">
                        <h3>步驟2.</h3>
                        <ul class="bullet-list">
                            <li><span>在 Office 外掛程式商店中搜尋「Trinka」</span></li>
                            <li><span>點選「新增」</span></li>
                            <li><span>然後點擊「繼續」開始安裝</span></li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image features-img">
                        <img src="/assets/images/word-plugin/step2.webp" width="918" height="523" alt="step2" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd list-wrapper-style-2 pb-0">
        <div class="trinka_container container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>步驟3.</h3>
                        <ul class="bullet-list">
                            <li><span>安裝完成後，請點選 Word 上方功能區的「Trinka」標籤</span></li>
                            <li><span>接著點擊「開啟 Trinka」</span></li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image">
                        <img src="/assets/images/word-plugin/step3.webp" width="925" height="238" alt="step3" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd list-wrapper-style-2 pb-0">
        <div class="trinka_container container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2 pr-80">
                        <h3>步驟4.</h3>
                        <ul class="bullet-list">
                            <li><span>使用你的 Trinka 帳號登入。</span></li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image features-img">
                        <img src="/assets/images/word-plugin/step4.webp" width="243" height="441" alt="step4" style="width: 243px;" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd list-wrapper-style-2 pb-0">
        <div class="trinka_container container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>步驟5.</h3>
                        <ul class="bullet-list">
                            <li><span>開始寫作，即可在 Word 中即時看到 Trinka 的建議。</span></li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image">
                        <img src="/assets/images/word-plugin/step5.webp" width="1091" height="627" alt="step5" class="img-fluid" />
                            <small class="note">請注意，輕量版（Lite 版本）不支援句子提醒功能。</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pb-0">
    <div class="trinka_container container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0 text-left">
                        <h2>支援下列系統版本</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    </div>
                    <ul class="bullet-list">
                        <li>Word 2019 或更新版本（適用於 Windows 和 Mac）</li>
                        <li>Microsoft 365 桌面版 Word（適用於 Windows 和 Mac）</li>
                        <li>Microsoft 365 網頁版 Word </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="/assets/images/compliance-mac.svg" width="456" height="424" alt="compare" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        在 Mac 上安裝 Trinka MS Word 的系統需求為何？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p class="mb-2">作業系統需為 OS X v10.10 "Yosemite" 或以上版本。</p>
                                        <p>MS Word 客戶端需至少為版本 15.18 (160109)，方可支援 Office 外掛程式。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionNine">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionNineContent" aria-expanded="true" aria-controls="QuestionNineContent">
                                        如何在 Mac/Windows 上使用 Trinka Word 外掛程式？</a>
                                </div>

                                <div id="QuestionNineContent" class="collapse" aria-labelledby="QuestionNine" data-parent="#faq">
                                    <div class="card-body">
                                        <div class="history-tl-container">
                                            <ul class="tl">
                                              <li class="tl-item" ng-repeat="item in retailer_history">
                                                <div class="item-title">登入帳號：</div>
                                                <div class="item-detail">安裝外掛後，在 Word 中登入 Trinka 帳號，升級至高級方案即可使用完整功能。
                                                </div>
                                              </li>
                                              <li class="tl-item" ng-repeat="item in retailer_history">
                                                <div class="item-title">檢查文法錯誤:</div>
                                                <div class="item-detail">開啟新檔或既有文件後，點選「Open Trinka」圖示。當你開始寫作時，Trinka 會即時檢測錯誤。</div>
                                              </li>
                                              <li class="tl-item" ng-repeat="item in retailer_history">
                                                <div class="item-title">套用文法修正：</div>
                                                <div class="item-detail">
                                                    <ul class="icon-list">
                                                        <li>點擊建議字詞可立即套用修正。</li>

                                                        <li>或點擊提示卡片以查看錯誤詳細說明與類別，Trinka 會標記文件中的錯誤位置。</li>
                                                            
                                                        <li>點選修改內容可立即套用，也可點選「倒讚」圖示以拒絕修正，該錯誤將不再顯示。</li>
                                                            
                                                        <li>點卡片頂部任一區域即可關閉提示卡。</li>
                                                    </ul>
                                                            
                                                </div>
                                               </li>
                                               <li class="tl-item pb-0" ng-repeat="item in retailer_history">
                                                <div class="item-title">設定選項</div>
                                                <div class="item-detail">
                                                    <p>錯誤類別提示 – 系統提供 4 種提示類別：</p>
                                                    <ul class="icon-list">
                                                        <li>文法修正 </li>
                                                        <li>語意增強</li>
                                                        <li>拼字錯誤</li>
                                                        <li>建議性修正</li>
                                                    </ul>
                                                    <br/>
                                                    <p>預設情況下，這四類錯誤提示全數啟用。若你希望根據類別篩選顯示內容，可自行取消勾選，系統會根據選擇調整總提示數量。</p>
                                                    
                                                    <p class="mt-20 mb-20">
                                                        <strong>語言選擇 –</strong> 可在英式英文與美式英文之間切換，提示內容也會隨之更新。
                                                    </p>
                    
                                                    <p class="mb-0">
                                                        <strong>風格指南選擇 –</strong> 可從下拉選單中選擇所需的寫作格式（如 APA、AMA 等），系統會依據所選格式更新建議內容。
                                                    </p>   
                                                </div>
                                               </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">Trinka 的 Microsoft Word 外掛程式是否能即時檢查拼字與文法？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的，Trinka Word 外掛程式會即時檢查並在您修改文字後重新提供建議。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        如何接受或拒絕 Trinka 的建議？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>只需點選建議字詞即可接受修正。如需拒絕，點選「倒讚」圖示。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        可以切換美式與英式英文嗎？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>可以。於功能區的「語言與設定」選單中選擇美式 (US) 或英式 (UK) 英文即可。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        可以選擇符合的寫作風格指南嗎？
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>可以。從「語言與設定」選單中選擇 APA、AMA、IEEE 等主流格式指南。
                                        </p>
                                    </div>
                                </div>
                            </div>


                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        安裝完成後找不到 Trinka 外掛怎麼辦？
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>可能是組織的安全設定阻擋了外掛啟用，請聯繫系統管理員協助開通權限。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEightSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightSectionContent" aria-expanded="true"
                                        aria-controls="QuestionEightSectionContent">
                                        Trinka 外掛程式無法偵測到寫作錯誤怎麼辦？
                                    </a>
                                </div>

                                <div id="QuestionEightSectionContent" class="collapse" aria-labelledby="QuestionEightSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>這可能是由於多種原因造成的：</p>
                                        <ul>
                                            <li>您可以嘗試以下幾個步驟來解決問題：
                                                確保電腦已連上網路</li>
                                            <li>確認外掛程式未被系統或公司安全設定停用
                                            </li>
                                            <li>嘗試從控制台解除安裝後重新安裝</li>
                                            <li>問題仍無法解決？請聯絡支援
                                                <a href="mailto:support@trinka.ai" class="text-link">support&#64;trinka.ai</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionNineSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionNineSectionContent" aria-expanded="true"
                                        aria-controls="QuestionNineSectionContent">
                                        Trinka Word 外掛是否支援 Office 365？
                                    </a>
                                </div>

                                <div id="QuestionNineSectionContent" class="collapse" aria-labelledby="QuestionNineSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的，Trinka 的 Word 外掛具備 Office 365 的文法檢查功能，可在 Office 365 環境中提供完整文法檢查。</p>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="card">
                                <div class="card-header" id="QuestionTenSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTenSectionContent" aria-expanded="true"
                                        aria-controls="QuestionTenSectionContent">
                                        How does Trinka's MS Word Add-In compare to Grammarly for Word in terms of grammar and spelling checking capabilities?
                                    </a>
                                </div>

                                <div id="QuestionTenSectionContent" class="collapse" aria-labelledby="QuestionTenSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's MS Word Add-In and Grammarly for Word both offer grammar and spelling checking capabilities. Designed specifically for technical and academic writing, Trinka offers features such as style guide selection, document type choice, and technical personalization options. Grammarly, on the other hand, is designed for generic grammar checking purposes.</p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="ListLiners hideWordPlugin">
    <app-trinka-in-other-apps></app-trinka-in-other-apps>
</section>